export { useForm, type AddonExtension } from './inertia';
